const configJson = {
  "client_id": "21at",
  "apikey": "h2j5k8s0",
  "publishAddress": "21atcloud.com.cn",
  "publishAddress_dev": "http://192.168.153.42:8088",
  "mapcubeUrl": "https://mapcube.21atcloud.com.cn/service/v1/img/china2023/3857/{z}/{x}/{y}.webp",//立即体验默认加载2023地图
  "reviewMapNumber":"GS (2024) 1614号",//首页底部-默认2023
  "initMapNumber":"GS (2024) 1614号",//立即体验一张图默认2023
  "mapServiceId":'china2023'//默认2023底图id
}
Object.freeze(configJson)
window.configJson = configJson;
export default configJson



// WEBPACK FOOTER //
// ./src/config.js